import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { HierarchyItem } from '../hierarchy-item';

@Component({
  selector: 'bom-hierarchy-item',
  templateUrl: './hierarchy-item.component.html',
  styleUrls: ['./hierarchy-item.component.scss'],
})
export class HierarchyItemComponent implements OnInit {
  @Input()
  item: HierarchyItem;

  @Input()
  addedItemIds$: Observable<string[]>;

  @Input()
  infos$: Observable<{ [id: string]: string }>;

  @Input()
  addButtonTextKey: 'Add' | 'Choose' = 'Add';

  @Input()
  isAddDisabled$: Observable<boolean> = of(false);

  @Output()
  clickAdd = new EventEmitter<HierarchyItem>();

  @Output()
  clickInfoIcon = new EventEmitter<HierarchyItem>();

  isAdded$: Observable<boolean>;
  info$: Observable<string>;

  constructor() {}

  ngOnInit() {
    this.isAdded$ = this.addedItemIds$.pipe(
      map(addedItemIds => addedItemIds.some(itemId => itemId === this.item.id))
    );
    this.info$ = this.infos$.pipe(map(infos => infos[this.item.id]));
  }
}
